import React, { useEffect, useState, useRef, useMemo } from 'react'
import { Grid } from '@material-ui/core'
import EurestoBlock from 'Components/EurestoBlock'
import EurestoTableSearch from 'Components/EurestoTableSearch'
import useActionRequest from 'EurestoHook/useActionRequest'
import Data from 'EurestoClass/Data'
import Utils from 'EurestoFonction/Utils'
import User from 'EurestoClass/User'

export default React.memo(props => {
  const [datas, setDatas] = useState(EurestoClone(props.datas || Data.list(props.module, props.requete, props.search || {}) || []))
  const actionRequest = useActionRequest(props.useActionRequest || {
    module: props.path || props.module,
    requete: props.requete,
    config: props.config || {}
  })
  const actions = useMemo(() => {
    return props.actionRequest || actionRequest
  }, [actionRequest, props.actionRequest])
  const [disabled, setDisabled] = useState(true)
  const [action, setAction] = useState(props.action)
  const [object, setObject] = useState(props.defaultObject || {})
  const [selectedRowIndex, setSelectedRowIndex] = useState(props.indexSelected || 0)
  const [newId, setNewId] = useState(null)
  const [isAllow, setIsAllow] = useState(props.isAllow || {
    add: true,
  })

  const [keyForm, setKeyForm] = useState(Utils.getRandomNumber())

  const restate = data => {
    const ds = Data.list(props.module, props.requete, props.search || {})
    setDatas(EurestoClone(ds || []))
  }

  useEffect(() => {
    if (datas && datas.length > 0) {
      if (newId) {
        const row = datas.find(d => d[props.columnSearch || 'id'] === newId)
        if (row) {
          setSelectedRowIndex(datas.findIndex(d => d[props.columnSearch || 'id'] === newId))
          setIsAllow(props.setAllow && props.setAllow(row) || {
            add: true,
            update: row.autorisation_modification === undefined || row.autorisation_modification === 1,
            delete: row.autorisation_modification === undefined || row.autorisation_modification === 1,
            archive: row.actif !== 0,
            unarchive: row.actif === 0,
            duplicate: true,
          })
        }
        setNewId(null)
      } else {
        (async () => {
          const row = datas[datas && datas.length >= selectedRowIndex && selectedRowIndex || datas && datas.length >= props.indexSelected && props.indexSelected || 0]
          const result = await actions.get({
            [props.columnSearch || 'id']: row[props.columnSearch || 'id']
          }) || null
          if (result && result.results && object[props.columnSearch || 'id'] !== result.results[props.columnSearch || 'id']) {
            setObject(result.results)
            setKeyForm(Utils.getRandomNumber())
            setIsAllow(props.setAllow && props.setAllow(row) || {
              add: true,
              update: row.autorisation_modification === undefined || row.autorisation_modification === 1,
              delete: row.autorisation_modification === undefined || row.autorisation_modification === 1,
              archive: row.actif !== 0,
              unarchive: row.actif === 0,
              duplicate: true,
            })
          }
        })()
      }
    } else {
      setSelectedRowIndex(null)
    }
  }, [datas])

  if (props.doNotHandleWs !== true) {
    useEffect(() => {
      Data.addCbRestate(props.module, props.requete, restate);
      (async () => {
        if (datas && datas.length > 0) {
          const row = datas[props.indexSelected || 0]
          const result = await actions.get({
            [props.columnSearch || 'id']: row[props.columnSearch || 'id']
          }) || null
          if (result && result.results && object.id !== result.results.id) {
            setObject(result.results)
            setKeyForm(Utils.getRandomNumber())
            setIsAllow(props.setAllow && props.setAllow(row) || {
              add: true,
              update: row.autorisation_modification === undefined || row.autorisation_modification === 1,
              delete: row.autorisation_modification === undefined || row.autorisation_modification === 1,
              archive: row.actif !== 0,
              unarchive: row.actif === 0,
              duplicate: true,
            })
          }
        }
      })()
      return () => Data.resetCbRestate(props.module, props.requete)
    }, [])
  }


  useEffect(() => {

    if (!_.isEqual(props.object || {}, object)) {
      setObject(props.object || {})
    }
  }, [props.object])

  const [table, setTable] = useState(null)
  const [form, setForm] = useState(null)

  const handleClickTable = async (row, index) => {
    if (row) {
      if (props.onClick) {
        props.onClick(row, index)
      } else {
        const result = await actions.get({
          [props.columnSearch || 'id']: row[props.columnSearch || 'id']
        }) || null
        if (result && result.results) {
          setObject(o => {
            if (o[props.columnSearch || 'id'] !== result.results[props.columnSearch || 'id']) {
              setSelectedRowIndex(index)
              setAction('view')
              setKeyForm(Utils.getRandomNumber())
              setIsAllow(props.setAllow && props.setAllow(row) || {
                add: true,
                update: row.autorisation_modification === undefined || row.autorisation_modification === 1,
                delete: row.autorisation_modification === undefined || row.autorisation_modification === 1,
                archive: row.actif !== 0,
                unarchive: row.actif === 0,
                duplicate: true,
              })
              return result.results
            }
            return o
          })
        }
      }
    }
  }

  useEffect(() => {
    setTable(_ => prps => (((!prps.matchesXs || prps.action === 'list') && props.showTable !== false) || props.showForm == false) &&
      <Grid item xs={(prps.matchesXs || props.showForm === false) && 12 || prps.matchesSm && 6 || 8}>
        {props.table && {
          ...props.table,
          props: {
            ...(props.table && props.table.props || {}),
            ...prps,
            datas: datas || [],
            columns: props.columns,
            onClick: handleClickTable,
            maxHeight: props.maxHeight || User.CalculHeight.getHeightWanted(43)
          }
        } ||
          <EurestoTableSearch infinityScroll={props.infinityScroll} columnSelected={props.columnSelected}
            search={props.search} maxHeight={props.maxHeight || User.CalculHeight.getHeightWanted(43)}
            selectedRowIndex={selectedRowIndex}
            selected={object}
            sort={props.sort}
            onClick={handleClickTable} datas={datas} columns={props.columns} />
        }
      </Grid>)
  }, [datas, selectedRowIndex])

  useEffect(() => {
    setForm(_ => prps => (((!prps.matchesXs || prps.action !== 'list') && props.showForm !== false) || props.showTable == false) &&
      <Grid key={keyForm} item xs={(prps.matchesXs || props.showTable === false) && 12 || prps.matchesSm && 6 || 4}
        style={{
          padding: 5,
          paddingBottom: 0,
          borderLeft: `1px solid ${EurestoColor('EurestoPrimary')}`,
          ...(props.formStyle || {})
        }}>
        {props.form && {
          ...props.form,
          props: {
            ...(props.form && props.form.props || {}),
            ...prps,
            object: object,
            disabled: disabled,
            onChange: handleObjectChange
          }
        }}
      </Grid>)
  }, [keyForm, disabled, object])

  const handleObjectChange = o => {
    setObject(EurestoClone(o))
  }

  const onChangeAction = async (act, prps, isSave) =>
    new Promise(async (resolve, reject) => {
      setObject(o => {
        if (!isSave) {
          setDisabled(true)
          if (datas && datas.length > 0) {
            const row = datas[props.indexSelected || 0]
            actions.get({
              [props.columnSearch || 'id']: row[props.columnSearch || 'id']
            }).then(result => {
              if (result && result.results && o.id !== result.results.id) {
                o = result.results
                setKeyForm(Utils.getRandomNumber())
                setIsAllow(props.setAllow && props.setAllow(row) || {
                  add: true,
                  update: row.autorisation_modification === undefined || row.autorisation_modification === 1,
                  delete: row.autorisation_modification === undefined || row.autorisation_modification === 1,
                  archive: row.actif !== 0,
                  unarchive: row.actif === 0,
                  duplicate: true,
                })
              }
              resolve(false)
            })
          }
        } else {
          if (props.handleAction && props.handleAction[act]) {
            props.handleAction[act](o)
            resolve(false)
          } else {
            actions[act](o)
              .then(result => {
                if (result && result.code === 1) {
                  if (act !== 'delete') {
                    setNewId(result[props.columnSearch || 'id'])
                    setDisabled(true)
                    o.id = result[props.columnSearch || 'id']
                    resolve(false)
                  } else {
                    setNewId(null)
                    resolve(false)
                  }
                } else {
                  resolve(true)
                }
              })
          }
        }
        return o
      })
    })

  const handleDisabled = dsl => {
    setDisabled(dsl)
    setKeyForm(Utils.getRandomNumber())
  }

  const handleNew = () => {
    setObject(EurestoClone(props.defaultObject || {}))
    setKeyForm(Utils.getRandomNumber())
    setNewId(null)
    setSelectedRowIndex(null)
  }

  return <EurestoBlock
    btns={props.btns}
    mainTabProps={{
      style: {
        width: props.showSearchComponent && props.showSearchComponent !== 'hide' && 250
      }
    }}
    isAllow={isAllow} handleNew={handleNew} action={action} handleDisabled={handleDisabled}
    onChangeAction={onChangeAction} tabs={[
      ...(props.showSearchComponent && props.showSearchComponent !== 'hide' && [{
        main: true,
        value: 0,
        form: false,
        title: <Grid container style={{ margin: 0, padding: "0px 5px", width: '100%' }} spacing={0} justify={'flex-start'}>{EurestoI18n.t('commun:Recherche')}</Grid>,
        children: _ => prps => <Grid container style={{ margin: 0, padding: 0, width: '100%', height: '100%' }} spacing={0}>
          {props.searchComponent}
        </Grid>
      }] || []),
      {
        form: true,
        main: !props.showSearchComponent || props.showSearchComponent === 'hide',
        value: !props.showSearchComponent || props.showSearchComponent === 'hide' ? 0 : 1,
        title: props.title,
        children: _ => prps => <Grid container spacing={0} style={{ margin: 0, padding: 0, width: '100%' }}
          wrap={'nowrap'}>
          {props.showTable !== false && table && table(prps)}
          {props.showForm !== false && form && form(prps)}
        </Grid>
      }
    ]} title={this.title === false ? false :
      <div style={{
        padding: '0px 5px 0px 0px',
        display: 'block',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '100%'
      }}>{
          selectedRowIndex !== null && selectedRowIndex >= 0 && datas && datas.length > selectedRowIndex && datas[selectedRowIndex][props.columnLibelle || 'libelle']
          || props.title
        }</div>}>
    {
      props.showSearchComponent === 'hide' &&
      <div style={{ display: 'none' }}>{props.searchComponent}</div>
    }
  </EurestoBlock>
})


// WEBPACK FOOTER //
// ./app/Components/Formulaire.js